<ng-container *ngIf="cartItemsWithTotals as itemsWithTotals">
	<div
		*ngFor="let itemWithTotal of itemsWithTotals; let i = index; trackBy: trackByItemId"
		class="cart-section-container"
		[class.cart-section-container--out-of-stock]="itemWithTotal.availabilityStatus === CartItemAvailabilityStatusEnum.OutOfStock"
		[class.cart-section-container--unavailable]="itemWithTotal.availabilityStatus === CartItemAvailabilityStatusEnum.Unavailable"
	>
		<img
			class="cart-section-element image"
			alt="No Image"
			[src]="(productChannel('imagen', itemWithTotal.item) | async) || no_image"
			(error)="onImgError($event)"
		/>

		<div class="cart-section-element">
			<span class="cart-section-item title">
				{{ productChannel('nombre', itemWithTotal.item) | async }}

				<span class="actions">
					<app-icon class="icon edit" iconName="edit" (click)="editItem(itemWithTotal.item)" />
					<app-icon class="icon trash" iconName="trash" (click)="deleteItem(itemWithTotal.item, i)" />
				</span>
			</span>

			<span class="cart-section-item description">
				{{ productChannel('descripcion', itemWithTotal.item) | async }}
			</span>

			<div
				*ngIf="itemWithTotal.availabilityStatus !== CartItemAvailabilityStatusEnum.Available"
				class="availability-warning"
				role="alert"
			>
				<strong>
					{{ itemWithTotal.availabilityStatus === CartItemAvailabilityStatusEnum.OutOfStock
						? translations['outOfStock']
						: translations['unavailable'] }}
				</strong>
				<span>
					{{ itemWithTotal.availabilityStatus === CartItemAvailabilityStatusEnum.OutOfStock
						? translations['outOfStockAction']
						: translations['unavailableAction'] }}
				</span>
			</div>

			<span class="cart-section-item price">
				<span class="price-value">
					{{ getPrice(itemWithTotal.item) | async | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision }}
					<span
						*ngIf="itemWithTotal.item.precio != itemWithTotal.item.specialPriceAmount"
						class="font-weight-bold text-gray mb-1"
						style="
							font-size: 0.8rem;
							color: #6c757d;
							text-decoration: line-through;
							position: absolute;
							top: -15px;
							left: 28px;
						"
					>
						{{ itemWithTotal.item.specialPriceAmount | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision }}
					</span>
				</span>

				<div class="container-stepper-actions">
					<app-quantity-stepper 
						[(ngModel)]="itemWithTotal.item.cantidad" 
						(changeStepper)="changeAmount(itemWithTotal.item, $event)"
						[max]="itemWithTotal.item.stock"
						 />
				</div>
			</span>
		</div>
	</div>
</ng-container>
